import React from 'react';
import TypeBox from '../helper/TypeBox';
import { skillColor } from '../helper/constants';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // height: '100vh',
    margin: '20px',
    // border: '1px solid red',
  },
  letter: {
    display: 'flex',
    justifyContent: 'center',
    // alignItems: 'center',
    backgroundColor: '#f7f7f7',
    alignItems: 'stretch', // Align items to stretch vertically. to get boxes in a row of same height
    // border: '1px solid orange',
    borderRadius: '10px',
    flexGrow: 1,
    margin: '3px',
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    // alignItems: 'center',
    alignItems: 'stretch', // Align items to stretch vertically. to get boxes in a row of same height
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
  },
  filterBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between', // Add space between buttons
    // border: '1px solid red',
    height: '100%', // Set height to 100%
    padding: '5px',
  },
  filterButton: {
    marginRight: '8px',
    padding: '4px 8px',
    borderRadius: '4px',
    // backgroundColor: '#eee',
    cursor: 'pointer',
    // color: 'white',
  },
  activeFilterButton: {
    // backgroundColor: skillColor,
    backgroundColor: 'white',
    color: skillColor,
    fontWeight: 'bold',
    fontSize: '16px',
  },
};

const TechLayout = ({
  activeCategory,
  setActiveCategory,
  uniqueCategories,
  handleCategoryClick,
}) => {
  // const [activeCategory, setActiveCategory] = useState('all');
  // const uniqueCategories = [
  //   ...new Set(TechArea.flatMap((tech) => tech.category)),
  // ];
  // const handleCategoryClick = (category) => {
  //   setActiveCategory(category);
  // };
  // order:
  //   B
  // A G C
  // D   E

  return (
    <div style={styles.container}>
      <div style={styles.column}>
        <div style={styles.row}>
          <div style={{ ...styles.letter, width: '100%' }}>
            {/* B */}
            <TypeBox
              key={'Frameworks/Libs'}
              type={'Frameworks/Libs'}
              category={activeCategory}
            />
          </div>
        </div>
        <div style={styles.row}>
          <div style={{ ...styles.letter, width: '40%' }}>
            {/* A */}
            <TypeBox
              key={'Programming/Configuration Languages'}
              type={'Programming/Configuration Languages'}
              category={activeCategory}
            />
          </div>

          <div
            style={{
              ...styles.letter,
              width: '25%',
              height: '100%',
              alignSelf: 'center',
              background:
                'linear-gradient(45deg, #C13584, #8134AF, #405DE6, #5851DB)',
            }}
          >
            {/* G filterBox middleBox */}
            <div style={styles.filterBox}>
              <label
                style={{
                  ...styles.filterButton,
                  ...(activeCategory === 'all' && styles.activeFilterButton),
                }}
              >
                <input
                  type='radio'
                  name='category'
                  value='all'
                  checked={activeCategory === 'all'}
                  onChange={() => handleCategoryClick('all')}
                />
                All
              </label>
              {/* Render the filter radio buttons for unique categories */}
              {uniqueCategories.map((category) => (
                <label
                  key={category}
                  style={{
                    ...styles.filterButton,
                    ...(activeCategory === category &&
                      styles.activeFilterButton),
                  }}
                >
                  <input
                    type='radio'
                    name='category'
                    value={category}
                    checked={activeCategory === category}
                    onChange={() => handleCategoryClick(category)}
                  />
                  {category}
                </label>
              ))}
            </div>
          </div>
          <div style={{ ...styles.letter, width: '35%' }}>
            {/* C */}
            <TypeBox key={'Tools'} type={'Tools'} category={activeCategory} />
          </div>
        </div>
        <div style={styles.row}>
          <div style={{ ...styles.letter, width: '60%' }}>
            {/* D */}
            <TypeBox key={'DevOps'} type={'DevOps'} category={activeCategory} />
          </div>
          <div style={{ ...styles.letter, width: '40%' }}>
            {/* E */}
            <TypeBox
              key={'Databases'}
              type={'Databases'}
              category={activeCategory}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechLayout;
